import React from 'react';
import PropTypes from 'prop-types';

import { Title, Message } from 'src/core/components';
import messages from '../../messages';

import './SummarySectionTitle.style.scss';

const SummarySectionTitle = ({ titleMessage = '', onEditClick }) => (
  <div className="review-title">
    <Title size="4" font="medium" message={titleMessage} />
    <div
      className="review-title_edit"
      onClick={() => onEditClick?.()}
      data-testid="review-title-edit"
    >
      <Message message={messages.editTitle} />
    </div>
  </div>
);

SummarySectionTitle.propTypes = {
  titleMessage: PropTypes.object.isRequired,
  onEditClick: PropTypes.func,
};

export default SummarySectionTitle;
